import { render, staticRenderFns } from "./PGEConfig.vue?vue&type=template&id=b7a20184&scoped=true"
import script from "./PGEConfig.vue?vue&type=script&lang=js"
export * from "./PGEConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a20184",
  null
  
)

export default component.exports